import { jsx } from 'react/jsx-runtime';
import { Box, Typography, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((_theme) => ({
    linkContainer: {
        marginTop: "15px",
        "&:first-child": {
            marginTop: "0"
        }
    },
    link: {}
}));
const Links = ({ links, ...props }) => {
    const { classes } = useStyles();
    return (jsx(Box, { ...props, children: links.map((link, i) => (jsx(Typography, { className: classes.linkContainer, children: jsx(Link, { "data-test-id": `link-${link}`, className: classes.link, href: link.includes("http") ? link : ("https://" + link), target: "_blank", rel: "noopener", children: link }, "link-" + i) }, i))) }));
};

export { Links as Link, Links };
